import dateFormat from "dateformat";
function ServicesContractLogItemView(props) {
  return (
    <tbody>
      <tr>
   
        <td width={150}> {dateFormat(props.EVENT_DATE, "dd-mmm-yy h:MM:ss TT")}</td>
        {/* <td  width={100}>{props.DATE_TEXT}</td> */}

        <td width={120}>
          <b>{props.USERNAME}</b>
        </td>
       
        <td>{props.REVISED_COLUMNS} </td>
        {/* <td>{props.REMARK}</td> */}
      </tr>
    </tbody>
  );
}
export default ServicesContractLogItemView;
